export default function nvl ( val, other ) {
    return ( val !== null && val !== undefined ) ? val : other
}